import { track as externalTracker } from '../../../external-libs/tracker';
export { NOT_SET } from '../../../external-libs/tracker/constants';

export function track(event, data) {
  return new Promise<void>((resolve, reject) => {
    try {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('[TRACK_EVENT]: ', event, data);
      } else {
        externalTracker(event, data);
      }
      resolve();
    } catch (e) {
      reject();
    }
  });
}
